/* generate year dorpdown list, numberOfYears is for how many years in the dropdown list,  isIincreased: 1 is for future years, 0 is for past years */
export const generateYearOptions = (numberOfYears,  isIincreased) => {
  const currentYear = new Date().getFullYear();
  
  return Array.from({ length: numberOfYears }, (_, index) => {
    const year = isIincreased? currentYear + index: currentYear - index ;  
    //const year = currentYear - (numberOfYears - 1 - index); oldest first
    const yearString = year.toString();
    return {
      id: (index + 1),  
      value: yearString,
      label: yearString,
      selected: false  
    };
  });
};